import { ReactNode, FunctionComponent } from "react";
import { ThemeProvider as EmotionProvider, Global, css } from "@emotion/react";
import emotionReset from "emotion-reset";

interface Props {
  children: ReactNode;
}

export const ThemeProvider: FunctionComponent<Props> = ({ children }) => {
  const theme = {};
  return (
    <EmotionProvider theme={theme}>
      <Global
        styles={css`
          ${emotionReset}
          color: white;

          button {
            cursor: pointer;
          }
        `}
      />
      {children}
    </EmotionProvider>
  );
};
